module.exports = __webpack_public_path__ + "static/media/wuyi_bg2.97e3e7bd.jpg";